<template>
  <div
    @click="$emit('click')"
    class="p-3 border rounded-lg shadow-sm bg-white text-sm w-fit leading-relaxed text-left cursor-pointer transition-all duration-200 ease-in-out hover:shadow-md min-w-[250px]"
    :class="active ? 'border-primary' : 'border-gray-200 hover:border-primary-300'"
  >
    <p v-if="!!formation"><strong>Formação:</strong> {{ formation }}</p>
    <p><strong>Valor por hora:</strong> {{ formattedValue }}</p>
    <p><strong>Mod. Repasse:</strong> {{ formattedRepassMode }}</p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = defineEmits(['click'])

const props = defineProps<{
  formation?: string
  value?: number
  repassMode: string
  active?: boolean
}>()

const formattedValue = computed(() =>
  props.value !== undefined ? `R$ ${props.value.toFixed(2).replace('.', ',')}` : null
)

const formattedRepassMode = computed(() => {
  const dictRepassMode: Record<string, string> = {
    FLOW: 'Fluxo',
    IMMEDIATE: 'À vista'
  }

  return dictRepassMode[props.repassMode] || 'Fluxo'
})
</script>
